module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image5.1fcb2b27.webp";